import MediumEditor from 'medium-editor';

const VideoHandler = MediumEditor.Extension.extend({
  name: 'video-handler',

  init() {
    MediumEditor.Extension.prototype.init.call(this);

    this.subscribe('editableKeydown', this.handleKeydown.bind(this));
    this.subscribe('editableInput', this.handleInputChange.bind(this));
  },

  handleKeydown(event) {
    if (event.key === 'Backspace') {
      this.handleBackspace();
    }
  },

  handleBackspace() {
    const currentElement = $(this.base.getSelectedParentElement());

    if (currentElement.hasClass('embedded-video')) {
      currentElement.remove();
    }
  },

  handleInputChange() {
    const currentElement = $(this.base.getSelectedParentElement());

    if (currentElement.hasClass('embedded-video')) {
      const playerId = currentElement.data('player-id');
      const videoHiddenNodes = currentElement.parents().find(`[data-player-id="${playerId}"]`).not(':has(iframe)');
      const videoNodesToRemove = currentElement.parents().find(`[data-player-id="${playerId}"]:has(iframe)`).not(':first');

      videoHiddenNodes.remove();
      videoNodesToRemove.remove();
    }
  },
});

export default VideoHandler;
